import React from "react";
import classNames from "classnames";

import styles from "./Layout.css";

export default function Content(_ref) {
  var children = _ref.children,
      className = _ref.className;

  return React.createElement(
    "main",
    { id: "main", role: "main", tabIndex: "-1", className: classNames(styles.main, className) },
    children
  );
}


// WEBPACK FOOTER //
// ./src/components/Library/Layout/Content.js